// The chat-bubble mark shown by Intercom's default white launcher.
export function IntercomMessengerIcon() {
    return (
        <svg viewBox="0 0 24 24" className="size-7" aria-hidden="true">
            <path
                fill="currentColor"
                d="M3.5 1.75h17a1.75 1.75 0 0 1 1.75 1.75v18.75l-4.1-2.05H3.5a1.75 1.75 0 0 1-1.75-1.75V3.5A1.75 1.75 0 0 1 3.5 1.75Z"
            />
            <path
                d="M5.5 15.75c3.75 3.3 9.25 3.3 13 0"
                fill="none"
                stroke="white"
                strokeLinecap="round"
                strokeWidth="1.3"
            />
        </svg>
    );
}
